//client\src\pages\Calendar\state\CalendarContext.js

import React, { createContext, useReducer, useContext } from "react";

import calendarReducer, {
    initialCalendarState,
} from "../../../context/reducers/calendarReducer";

const CalendarContext = createContext(null);

export const CalendarProvider = ({ children }) => {
    const [state, dispatch] = useReducer(
        calendarReducer,
        initialCalendarState
    );

    return (
        <CalendarContext.Provider value={{ state, dispatch }}>
            {children}
        </CalendarContext.Provider>
    );
};

export const useCalendar = () => {
    const ctx = useContext(CalendarContext);
    if (!ctx) {
        throw new Error("useCalendar must be used inside CalendarProvider");
    }
    return ctx;
};
